import _ from 'lodash';
import applyInfo from './applyInfo';

export default _.union(
  applyInfo,
  [{
    name: 'carInsuranceSystem',
    path: '/carInsuranceSystem',
    meta: { title: '保险系统' },
    component: require('views/common/blank.vue').default
  }]
);
